/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import {
  OnInit,
  Component,
  Input,
  ViewChild,
  EventEmitter,
  Output,
  ElementRef,
} from '@angular/core';
import { MouseEventType } from '../../../common/enums';
import { BrowserService } from '../../services/browser.service';

@Component({
  selector: 'xrx-toggle-switch',
  templateUrl: './xrx-toggle-switch.component.html',
  styleUrls: ['./xrx-toggle-switch.component.less'],
  standalone: false,
})
export class XrxToggleSwitchComponent implements OnInit {
  browserType: number;

  @ViewChild('switch', { static: false }) switch: ElementRef;
  @Input() label: string;
  @Input() icon: any;
  @Input() image: any;
  @Input() glyph: any;
  @Input() switchOn: boolean;
  @Input() isMfd: boolean;
  @Input() isRedact: boolean;
  @Input() disabled = false;
  @Output() toggle = new EventEmitter<boolean>();

  constructor(private browserService: BrowserService) {
    this.browserType = this.browserService.browserType();
  }

  public get MouseEventType(): typeof MouseEventType {
    return MouseEventType;
  }

  ngOnInit(): void {
    if (
      this.switchOn === true ||
      (typeof this.switchOn === 'string' && this.switchOn === 'true')
    ) {
      this.switchOn = true;
    } else {
      this.switchOn = false;
    }

    this.switchOffPos = this.isMfd ? -55 : -40;
  }

  mouseStatus: MouseEventType;
  switchOnPos = 0;
  switchOffPos = 0;

  onClick(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      this.mouseStatus = MouseEventType.Pressed;
    }
  }

  onUnClick(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      this.onToggle(e);
      this.mouseStatus = MouseEventType.Released;
    }
  }

  onLeave(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      if (this.mouseStatus == MouseEventType.Pressed) {
        this.mouseStatus = MouseEventType.Outed;
        this.onUnClick(e);
      }
    }
  }

  onDrag(e: MouseEvent) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      if (this.mouseStatus == MouseEventType.Pressed) {
        let pos = this.switch.nativeElement.style.left;
        let newPos = 0;

        if (!pos) {
          pos = this.switchOn ? this.switchOnPos : this.switchOffPos;
        } else {
          pos = Number(pos.slice(0, -2)); // trim "px"
        }

        // toward right
        if (e.movementX > 0 && pos < this.switchOnPos) {
          newPos = pos + e.movementX;
          newPos = newPos > this.switchOnPos ? this.switchOnPos : newPos;
        }
        //toward left
        else if (e.movementX < 0 && pos > this.switchOffPos) {
          newPos = pos + e.movementX;
          newPos = newPos < this.switchOffPos ? this.switchOffPos : newPos;
        } else {
          newPos = pos;
        }

        if (newPos !== pos) {
          // move the switch
          this.switch.nativeElement.style.left = newPos + 'px';
        }
      }
    }
  }

  onTap(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      if (!(e.target as HTMLElement).classList.contains('tg')) {
        this.onToggle(e);
      }
    }
  }

  onToggle(e: Event) {
    if (this.switch.nativeElement.style.left) {
      const pos = Number(this.switch.nativeElement.style.left.slice(0, -2));
      if (
        (pos >= this.switchOffPos / 2 && this.switchOn) ||
        (pos <= this.switchOffPos / 2 && !this.switchOn)
      ) {
        setTimeout(() => {
          this.switch.nativeElement.style.left = '';
        });
        return;
      }
    }

    this.switchOn = !this.switchOn;
    this.toggle.emit(this.switchOn);
    setTimeout(() => {
      this.switch.nativeElement.style.left = '';
    });
  }
}
